module.exports = __webpack_public_path__ + "img/canvas-bg.a504aa17.png";